'use client'
import {
  EditIcon,
  LocationIcon,
  PlusIcon,
  TrashIcon,
} from '@/_assets/icon-components'
import TrashRed from '@/_assets/icon-components/TrashRed'
import ConfirmModal from '@/_components/ConfirmModal'
import {
  onOpenMap,
  openPoint,
  removePoint,
  setMapModalLg,
} from '@/_store/common/common.slice'
import { IRedux } from '@/_store/types'
import { Box, Button, Flex, IconButton, Stack, Text } from '@chakra-ui/react'
import { useTranslations } from 'next-intl'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

const Addresses = () => {
  const [isOpen, setIsOpen] = useState({
    address: '',
    open: false,
    id: '',
  })

  const t = useTranslations()
  const { points } = useSelector((state: IRedux) => state.common)
  const dispatch = useDispatch()

  return (
    <Stack>
      {points?.map((item) => (
        <Flex
          align='center'
          justifyContent={'space-between'}
          gap={2}
          key={item?.id}
        >
          <Flex alignItems={'center'} gap={2}>
            <Box bg={'light.300'} p={3} rounded={16} w={'48px'} h={'48px'}>
              <LocationIcon />
            </Box>
            <Text fontWeight={400} lineHeight={'24px'}>
              {item?.address}
            </Text>
          </Flex>
          <Flex>
            <IconButton
              variant='ghost'
              rounded={8}
              aria-label='Edit address'
              onClick={() => {
                dispatch(setMapModalLg(true))
                dispatch(openPoint(item))
              }}
            >
              <EditIcon />
            </IconButton>
            <IconButton
              color='error'
              variant='ghost'
              aria-label='Edit address'
              rounded={8}
              onClick={() =>
                setIsOpen({
                  address: item?.address,
                  open: true,
                  id: item?.id,
                })
              }
            >
              <TrashRed />
            </IconButton>
          </Flex>
        </Flex>
      ))}
      <Button
        mt={6}
        w='full'
        h='48px'
        rounded={16}
        variant='plain'
        color='primary'
        border='1px solid'
        borderColor='primary'
        _hover={{ bgColor: 'primary', color: 'light' }}
        size='lg'
        onClick={() => dispatch(onOpenMap())}
      >
        <PlusIcon color='currentColor' /> {t('add_new_address')}
      </Button>
      <ConfirmModal
        isOpen={isOpen?.open}
        onConfirm={() => {
          dispatch(removePoint(isOpen?.id))
          setIsOpen({
            address: '',
            open: false,
            id: '',
          })
        }}
        title={t('deleted_address')}
        onClose={() =>
          setIsOpen({
            address: '',
            open: false,
            id: '',
          })
        }
        text={{ confirm: 'confirm', cancel: 'cancel' }}
        // description={t('confirm_delete_card')}
      />
    </Stack>
  )
}

export default Addresses
